import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from 'antd'
import Login from './pages/Login'
import Register from './pages/Register'
import Dashboard from './pages/Dashboard'
import Search from './pages/Search'
import Articles from './pages/Articles'
import ArticleDetail from './pages/ArticleDetail'
import Tags from './pages/Tags'
import Folders from './pages/Folders'
import Settings from './pages/Settings'
import Tools from './pages/Tools'
import PrivateRoute from './components/PrivateRoute'
import './App.css'

function App() {
  return (
    <Layout className="app-layout">
      <Routes>
        {/* 公开路由 */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        
        {/* 受保护的路由 */}
        <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/search" element={<PrivateRoute><Search /></PrivateRoute>} />
        <Route path="/articles" element={<PrivateRoute><Articles /></PrivateRoute>} />
        <Route path="/articles/:id" element={<PrivateRoute><ArticleDetail /></PrivateRoute>} />
        <Route path="/tags" element={<PrivateRoute><Tags /></PrivateRoute>} />
        <Route path="/folders" element={<PrivateRoute><Folders /></PrivateRoute>} />
        <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
        <Route path="/tools" element={<PrivateRoute><Tools /></PrivateRoute>} />
        
        {/* 默认重定向 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  )
}

export default App
